import React from 'react';

const Error = ({ errors, onClose }) => {
  if (!errors || Object.keys(errors).length === 0) return null;

  return (
    <div style={styles.alertContainer}>
      <div style={styles.alert}>
        <button onClick={onClose} style={styles.closeButton}>
          &times;
        </button>
        <ul>
          {Object.entries(errors).map(([field, messages]) =>
            messages?.map((msg, index) => (
              <li key={`${field}-${index}`} style={styles.errorMessage}>
                {msg}
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  );
};

const styles = {
  alertContainer: {
    position: 'relative',
    marginBottom: '1rem',
  },
  alert: {
    backgroundColor: '#f8d7da',
    color: '#721c24',
    padding: '1rem',
    border: '1px solid #f5c6cb',
    borderRadius: '0.25rem',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: '0.5rem',
    right: '0.5rem',
    background: 'transparent',
    border: 'none',
    fontSize: '1.25rem',
    cursor: 'pointer',
    color: '#721c24',
  },
  errorMessage: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
};

export default Error;
